export default "__VITE_ASSET__RaDRBUqm__"